import { createSlice } from "@reduxjs/toolkit";
import { ROLES_LIST } from "../roles/roles.config";

/**
 * Rollen-Vorschau — rein clientseitige Simulation.
 * Backend-Rechte bleiben unberührt; nur Navigation, Route-Guards und
 * useAuth-abhängige UI werden beeinflusst.
 *
 * previewRole speichert den *numerischen* Rollenwert (z. B. 2002 für Mitglied).
 * getEffectiveRoles() liefert ein synthetisches roles-Array passend zur
 * gewählten Vorschau-Rolle (inklusive aller niedrigeren Rollen, analog zum
 * realen Rollenmodell).
 */

// Mapping: preview role value → synthetic roles array
const ROLE_HIERARCHY = {
  [ROLES_LIST.Mitglied]: [ROLES_LIST.Mitglied],
  [ROLES_LIST.User]: [ROLES_LIST.User, ROLES_LIST.Mitglied],
  [ROLES_LIST.Editor]: [ROLES_LIST.Editor, ROLES_LIST.User, ROLES_LIST.Mitglied],
  [ROLES_LIST.Admin]: [
    ROLES_LIST.Admin,
    ROLES_LIST.Editor,
    ROLES_LIST.User,
    ROLES_LIST.Mitglied,
  ],
};

const rolePreviewSlice = createSlice({
  name: "rolePreview",
  initialState: {
    isActive: false,
    previewRole: null, // numeric role value
    originPath: null, // path to return to after preview ends
  },
  reducers: {
    startRolePreview: (state, action) => {
      const { role, originPath } = action.payload;
      state.isActive = true;
      state.previewRole = role;
      state.originPath = originPath || "/dashboard/app";
    },
    stopRolePreview: (state) => {
      state.isActive = false;
      state.previewRole = null;
      state.originPath = null;
    },
  },
});

export const { startRolePreview, stopRolePreview } = rolePreviewSlice.actions;
export default rolePreviewSlice.reducer;

// --- Selectors ---

export const selectRolePreview = (state) => state.rolePreview;
export const selectIsPreviewActive = (state) => state.rolePreview.isActive;
export const selectPreviewRole = (state) => state.rolePreview.previewRole;
export const selectOriginPath = (state) => state.rolePreview.originPath;

/**
 * Returns the effective roles array.
 * When preview is active → synthetic hierarchy for the chosen role.
 * Otherwise → real auth roles from JWT.
 */
export const selectEffectiveRoles = (state) => {
  if (state.rolePreview.isActive && state.rolePreview.previewRole != null) {
    return ROLE_HIERARCHY[state.rolePreview.previewRole] || [];
  }
  return state.auth.roles;
};
